import { Button } from "@d12labs/ui/button";
import { type ErrorComponentProps, Link } from "@tanstack/react-router";
import { AuthLayout } from "@/components/pages/auth-layout";

// Rendered by TanStack Router whenever a route's beforeLoad, loader, or
// component throws. Apps that ship this chassis to end users will likely
// want to hide the raw error message — for the chassis itself we surface
// it so dev-time crashes are debuggable without opening DevTools.
export function ErrorPage({ error, reset }: ErrorComponentProps) {
	// The router types a thrown value as `unknown` — anything can be thrown.
	const message = error instanceof Error ? error.message : String(error ?? "");
	return (
		<AuthLayout
			title="Something went wrong"
			description="An unexpected error interrupted the page."
		>
			<div className="flex flex-col gap-4">
				{message ? (
					<pre className="rounded border border-hairline bg-surface-2 p-3 text-xs text-ink-muted overflow-x-auto whitespace-pre-wrap">
						{message}
					</pre>
				) : null}
				<div className="flex flex-col gap-2">
					<Button onClick={reset} className="w-full">
						Try again
					</Button>
					<Link to="/home">
						<Button variant="outline" className="w-full">
							Take me home
						</Button>
					</Link>
				</div>
			</div>
		</AuthLayout>
	);
}
